import React from 'react'
import MaterialSymbol from '../material-symbol'

const SyncAlt = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="sync_alt" {...props} />
))

SyncAlt.displayName = 'SyncAlt'

export default SyncAlt
